



















import Vue from 'vue'
import { Swiper as SwiperClass, Autoplay, Navigation } from 'swiper'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'

// Swiper modules
SwiperClass.use([Navigation, Autoplay])

const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass)
const IMAGE_DATA = [
  { image: '/static/top/bnr-voices.png', link: '/voices', alt: 'お客さまの声' },
  { image: '/static/top/slide02.png', link: '/support/categories/360001626191/sections/360004193611/contents/360026136552', alt: 'Tポイントとは？' },
  { image: '/static/top/slide03.png', link: '/guide', alt: 'ご利用ガイド' }
]

export default Vue.extend({
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      imageData: IMAGE_DATA,
      width: window.innerWidth,
      height: window.innerHeight,
      isUseSwiperSlider: false,
      swiperOption: {
        spaceBetween: 24,
        centeredSlides: true,
        initialSlide: 1,
        speed: 1100,
        loop: true,
        autoplay: {
          delay: 2800,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: '.swiperNext',
          prevEl: '.swiperPrev'
        },
        breakpoints: {
          500: {
            slidesPerView: 2
          },
          1: {
            slidesPerView: 1
          }
        }
      },
      slickOptions: {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 3,
        easing: 'ease-in',
        centerMode: true,
        autoplay: true,
        pauseOnHover: false,
        responsive: [
          {
            breakpoint: 892,
            settings: {
              slidesToShow: 1,
              variableWidth: true
            }
          }
        ]
      }
    }
  },
  mounted() {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.width = window.innerWidth
      if (this.width < 800) {
        this.isUseSwiperSlider = true
      } else {
        this.isUseSwiperSlider = false
      }
    }
  }
})
